Object.defineProperty(exports, "__esModule", { value: true });
exports.iframeReset = void 0;
exports.iframeReset = {
    ncss: {},
};
//# sourceMappingURL=iframe-reset.js.map